export default [
  {
    path: '/backend',
    component: () => import('../components/Backend/BackendLayout'),
    meta: { requiresAuth: true },
    children: [
      //首頁
      {
        path: 'home',
        name: 'backend-index',
        meta: { title: '首頁' },
        component: () => import('../views/Backend/Home-Page.vue')
      },
      //業務
      {
        path: 'appointment-setting',
        name: 'backend-appointmentSetting',
        meta: { title: '預約設定管理' },
        component: () => import('../views/Backend/AppointmentSetting-Page.vue')
      },
      {
        path: 'appointment-record',
        name: 'backend-appointmentRecord',
        meta: { title: '民眾預約紀錄' },
        component: () => import('../views/Backend/AppointmentRecord-Page.vue')
      },
      {
        path: 'vaccineCategory',
        name: 'backend-vaccineCategory',
        meta: { title: '疫苗類別管理' },
        component: () => import('../views/Backend/VaccineCategory-Page.vue')
      },
      {
        path: 'vaccine',
        name: 'backend-vaccine',
        meta: { title: '疫苗管理' },
        component: () => import('../views/Backend/Vaccine-Page.vue')
      },
      //篩檢設定管理
      {
        path: 'healthcheck-setting',
        name: 'backend-healthcheckSetting',
        meta: { title: '健檢預約設定' },
        component: () => import('../views/Backend/HealthCheckSetting-Page.vue')
      },
      {
        path: 'healthcheck-record',
        name: 'backend-healthcheckRecord',
        meta: { title: '民眾健檢預約紀錄' },
        component: () => import('../views/Backend/HealthCheckRecord-Page.vue')
      },
      //前台
      {
        path: 'faqCategory',
        name: 'backend-faqCategory',
        meta: { title: '常見問題分類管理' },
        component: () => import('../views/Backend/Common/FaqCategory-Page.vue')
      },
      {
        path: 'faq',
        name: 'backend-faq',
        meta: { title: '常見問題管理' },
        component: () => import('../views/Backend/Common/Faq-Page.vue')
      },
      {
        path: 'frontendSetting',
        name: 'backend-frontendSetting',
        meta: { title: '頁面文字設定' },
        component: () => import('../views/Backend/Common/FrontendSetting-Page.vue')
      },
      {
        path: 'newsCategory',
        name: 'backend-newsCategory',
        meta: { title: '最新消息分類管理' },
        component: () => import('../views/Backend/Common/NewsCategory-Page.vue')
      },
      {
        path: 'news',
        name: 'backend-news',
        meta: { title: '最新消息管理' },
        component: () => import('../views/Backend/Common/News-Page.vue')
      },
      //後台
      {
        path: 'role',
        name: 'backend-role',
        meta: { title: '角色管理' },
        component: () => import('../views/Backend/Common/Role-Page.vue')
      },
      {
        path: 'pageTree',
        name: 'backend-pageTree',
        meta: { title: '功能結構管理' },
        component: () => import('../views/Backend/Common/PageTree-Page.vue')
      },
      //系統管理
      {
        path: 'profile',
        name: 'backend-profile',
        meta: { title: '個人帳號' },
        component: () => import('../views/Backend/Common/Profile-Page.vue')
      },
      {
        path: 'account',
        name: 'backend-account',
        meta: { title: '帳號管理' },
        component: () => import('../views/Backend/Common/Account-Page.vue')
      },
      {
        path: 'organization',
        name: 'backend-organization',
        meta: { title: '機構管理' },
        component: () => import('../views/Backend/Common/Organization-Page.vue')
      },
      {
        path: 'systemSetting',
        name: 'backend-systemSetting',
        meta: { title: '系統設定' },
        component: () => import('../views/Backend/Common/SystemSetting-Page.vue')
      },
      {
        path: 'paramSetting',
        name: 'backend-paramSetting',
        meta: { title: '參數設定' },
        component: () => import('../views/Backend/Common/SystemSetting-Page.vue')
      },
      //資安查核
      {
        path: 'mailLog',
        name: 'backend-mailLog',
        meta: { title: '信件發送紀錄' },
        component: () => import('../views/Backend/Audit/MailLog-Page.vue')
      },
      {
        path: 'smsLog',
        name: 'backend-smsLog',
        meta: { title: '簡訊發送紀錄' },
        component: () => import('../views/Backend/Audit/SmsLog-Page.vue')
      },
      {
        path: 'operationLog',
        name: 'backend-operationLog',
        meta: { title: '操作紀錄' },
        component: () => import('../views/Backend/Audit/OperationLog-Page.vue')
      },
      {
        path: 'loginLog',
        name: 'backend-logingLog',
        meta: { title: '登入紀錄' },
        component: () => import('../views/Backend/Audit/LogingLog-Page.vue')
      },
      {
        path: 'interfaceLog',
        name: 'backend-interfaceLog',
        meta: { title: '第三方介接' },
        component: () => import('../views/Backend/Audit/InterfaceLog-Page.vue')
      },
      //報表
      {
        path: 'reportVolume',
        name: 'report-volume',
        meta: { title: '預約總量與趨勢報表' },
        component: () => import('../views/Backend/Report/Volume-Page.vue')
      },
      {
        path: 'reportAgeDistribution',
        name: 'report-ageDistribution',
        meta: { title: '預約人群年齡分布報表' },
        component: () => import('../views/Backend/Report/AgeDistribution-Page.vue')
      },
      {
        path: 'reportVaccinePreference',
        name: 'report-vaccinePreference',
        meta: { title: '疫苗品牌/劑型預約比例報表' },
        component: () => import('../views/Backend/Report/VaccinePreference-Page.vue')
      },
      {
        path: 'reportRegionCompletion',
        name: 'report-regionCompletion',
        meta: { title: '地區別預約完成率報表' },
        component: () => import('../views/Backend/Report/RegionCompletion-Page.vue')
      },
      {
        path: 'reportOrganizationLoad',
        name: 'report-organizationLoad',
        meta: { title: '接種地點預約負載報表' },
        component: () => import('../views/Backend/Report/OrganizationLoad-Page.vue')
      },
      {
        path: 'reportCancellation',
        name: 'report-cancellation',
        meta: { title: '預約取消/未到情形報表' },
        component: () => import('../views/Backend/Report/Cancellation-Page.vue')
      },
      {
        path: 'reportPeak',
        name: 'report-peak',
        meta: { title: '預約高峰時段分析報表' },
        component: () => import('../views/Backend/Report/PeakTime-Page.vue')
      },
      {
        path: 'reportSpecialGroup',
        name: 'report-specialGroup',
        meta: { title: '特殊族群預約統計報表' },
        component: () => import('../views/Backend/Report/SpecialGroup-Page.vue')
      },
      {
        path: 'reportSmsHistory',
        name: 'report-smsHistory',
        meta: { title: '每日寄送簡訊報表' },
        component: () => import('../views/Backend/Report/SmsHistory-Page.vue')
      },
      //Error
      {
        path: 'error500',
        name: 'backend-error500',
        meta: { title: '500' },
        component: () => import('../views/Backend/Error/Error-500.vue')
      },
      {
        path: 'error403',
        name: 'backend-error403',
        meta: { title: '403' },
        component: () => import('../views/Backend/Error/Error-403.vue')
      },
      {
        path: ':catchAll(.*)',
        name: 'backend-notFound',
        meta: { title: '404' },
        component: () => import('../views/Backend/Error/Error-404.vue')
      }
    ]
  }
]
